import React, { useContext } from "react";
import classNames from "classnames";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import InfoBlock from "../../../../../common/InfoBlock";
import { LogRenderContext } from "../LogRenderer";
import GetUpdatedOnBy from "../GetUpdatedOnBy";
import TheatreAndScreensDetailsPanel from "../TargetGroupTable";
import { applyScreenModifications, commonConfig, fillMissingValidityWithOldValues } from "../utils";
import { getUserTimeZone } from "../../../../../../utils";
import { formatValidityPeriod } from "../../../../../../utils/formatValidity";

const TargetGroupCreatedAndUpdated = ({ type }) => {
  const isCreated = type === "created";
  const { log } = useContext(LogRenderContext);
  const { targetGroups: targetGroupsChanges } = log.changedFields || {};
  const targetGroupNew = targetGroupsChanges[0] || {};
  const { targetGroups } = log.dataSnapshot;
  const targetGroup = !isCreated
    ? targetGroups.find((tg) => tg.id === targetGroupNew?.id) || {}
    : targetGroups[0];

  const screens =
    targetGroups.length > 0
      ? targetGroups
          .map((tg) => tg.screens)
          .flat()
          .filter((f) => f)
      : [];
  const screenChanges =
    targetGroupsChanges.length > 0 && !isCreated
      ? targetGroupsChanges
          .map((tg) => tg.screens)
          .filter((t) => t)
          .flat()
      : [];

  const { screensWithChanges, addedScreenCount, removedScreenCount } = applyScreenModifications(
    screens,
    screenChanges
  );
  return (
    <div
      className={styles.tabContainer}
      style={{ display: "flex", flexDirection: "column", gap: "5px" }}
    >
      <div className={styles.badgeContainer}>
        <div className={styles.campaignName}>{targetGroup.name}</div>
        <div
          className={classNames(
            styles.badge,
            isCreated ? styles.badgeSuccess : styles.badgeUpdated
          )}
        >
          {isCreated ? "Created" : "Updated"}
        </div>
      </div>
      {isCreated ? (
        <GetUpdatedOnBy updatedAt={targetGroup?.updatedAt} updatedBy={targetGroup?.updatedBy} />
      ) : (
        <GetUpdatedOnBy
          updatedAt={targetGroupNew?.updatedAt}
          updatedBy={targetGroupNew?.updatedBy}
        />
      )}
      <InfoBlock
        header="Target Group Details"
        className={styles.changeTracking}
        config={commonConfig([
          {
            title: "Target Group Name",
            value: { old: targetGroup.name, new: targetGroupNew.name },
          },
          {
            title: `Validity  (${getUserTimeZone().abbr})`,
            value: {
              old: formatValidityPeriod(targetGroup?.validity),
              new: formatValidityPeriod(
                fillMissingValidityWithOldValues(targetGroup?.validity, targetGroupNew?.validity)
              ),
            },
          },
        ])}
      />
      <div className={styles.campaignName}>
        {`Screens (${screensWithChanges.length - removedScreenCount ?? 0})`}
        {!!addedScreenCount && (
          <span className={classNames(styles.badge, styles.badgeSuccess)}>
            {`Added ${addedScreenCount}`}
          </span>
        )}
        {!!removedScreenCount && (
          <span className={classNames(styles.badge, styles.badgeError)}>
            {`Removed ${removedScreenCount}`}
          </span>
        )}
      </div>
      <TheatreAndScreensDetailsPanel
        screens={screensWithChanges}
        targetGroupsName={[targetGroup.name]}
      />
    </div>
  );
};

export default TargetGroupCreatedAndUpdated;
